import React from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage, t } from '../utils/i18n';
import { motion } from 'framer-motion';

const LegalPage = () => {
  const { type } = useParams();
  const { language } = useLanguage();
  const [legalContent, setLegalContent] = React.useState([]);
  const [title, setTitle] = React.useState('');
  
  React.useEffect(() => {
    const fetchLegalContent = async () => {
      try {
        const response = await import('../data/legal.json');
        const data = response.default;
        
        if (type === 'terms') {
          setLegalContent(data.termsOfService[language.code] || data.termsOfService.es);
          setTitle(t('footer.terms', language.code));
        } else if (type === 'privacy') {
          setLegalContent(data.privacyPolicy[language.code] || data.privacyPolicy.es);
          setTitle(t('footer.privacy', language.code));
        }
      } catch (error) {
        console.error('Failed to load legal content:', error);
      }
    };
    
    fetchLegalContent();
  }, [type, language.code]);
  
  return (
    <div className="py-12">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-white p-8 rounded-lg shadow-md"
        >
          <h1 className="text-3xl font-bold text-akasha-black mb-8 pb-4 border-b border-akasha-beige">
            {title}
          </h1>
          
          <div className="prose max-w-none">
            {legalContent.map((paragraph, index) => (
              <p key={index} className="mb-4 text-gray-700">
                {paragraph}
              </p>
            ))}
            
            {legalContent.length === 0 && (
              <p className="text-gray-500 italic">
                {language.code === 'es' 
                  ? 'Cargando contenido...' 
                  : 'Loading content...'}
              </p>
            )}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LegalPage;
